(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .factory('UtilsService', UtilsService);

  function UtilsService() {
    return {
      getUrl
    };

    function getUrl(url) {
      if (url && url.includes('http')) {
        return url;
      // eslint-disable-next-line no-else-return
      } else {
        return `${SERVER}${url}`;
      }
    }
  }
}());
